// Kakao Maps JS SDK 로더 (싱글턴). 좌표 픽커 등 지도가 필요한 화면에서 공용.
const KAKAO_SDK_URL = "https://dapi.kakao.com/v2/maps/sdk.js";

let sdkLoadPromise: Promise<void> | null = null;

export function loadKakaoSdk(): Promise<void> {
  if (sdkLoadPromise) return sdkLoadPromise;

  sdkLoadPromise = new Promise((resolve, reject) => {
    if (typeof kakao !== "undefined" && kakao.maps) {
      kakao.maps.load(() => resolve());
      return;
    }

    const appKey = import.meta.env.VITE_KAKAO_MAP_KEY as string | undefined;
    if (!appKey) {
      sdkLoadPromise = null;
      reject(new Error("VITE_KAKAO_MAP_KEY 환경변수가 설정되지 않았습니다."));
      return;
    }

    const script = document.createElement("script");
    script.src = `${KAKAO_SDK_URL}?appkey=${appKey}&autoload=false`;
    script.async = true;
    script.onload = () => kakao.maps.load(() => resolve());
    script.onerror = () => {
      sdkLoadPromise = null;
      reject(new Error("Kakao Maps SDK 로딩 실패 — 카카오 개발자 콘솔에 이 도메인이 등록됐는지 확인하세요."));
    };
    document.head.appendChild(script);
  });

  return sdkLoadPromise;
}
